"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _lodash2 = _interopRequireDefault(require("lodash.isempty"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactComponents = require("@cimpress/react-components");

var _reactI18next = require("react-i18next");

var _Claim = _interopRequireDefault(require("./Claim"));

var _useClaims2 = _interopRequireDefault(require("./hooks/useClaims"));

var _environments = require("../constants/environments");

var _i18n = _interopRequireDefault(require("../i18n"));

var _propTypes2 = require("../propTypes");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: 16px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Spinner = _reactComponents.shapes.Spinner;

var ViewAllWrapper = _styledComponents["default"].div(_templateObject());

var getGlobalFulfillerIds = function getGlobalFulfillerIds(tenant, queryParameters) {
  if ((0, _lodash["default"])(queryParameters, 'globalFulfillerId')) {
    return queryParameters.globalFulfillerId;
  }

  return !(0, _lodash2["default"])(tenant) ? [tenant.tenantValue] : null;
};

var generateLinkToComplaintsUi = function generateLinkToComplaintsUi(environment, tenant, queryParameters) {
  var complaintsUiBaseUrl = "https://".concat(environment === _environments.PRODUCTION ? '' : 'int-', "complaints.commerce.cimpress.io");
  var globalFulfillerIds = getGlobalFulfillerIds(tenant, queryParameters);
  var filterQueryString = (0, _lodash2["default"])(globalFulfillerIds) ? '' : "?".concat(globalFulfillerIds.map(function (id) {
    return "globalFulfillerId[]=".concat(id);
  }));
  var link = "".concat(complaintsUiBaseUrl, "/fulfillerClaims").concat(filterQueryString);
  return link;
};

var Claims = function Claims(_ref) {
  var accessToken = _ref.accessToken,
      environment = _ref.environment,
      language = _ref.language,
      locale = _ref.locale,
      displayLimit = _ref.displayLimit,
      tenant = _ref.tenant,
      queryParameters = _ref.queryParameters,
      title = _ref.title,
      displayInCard = _ref.displayInCard,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["accessToken", "environment", "language", "locale", "displayLimit", "tenant", "queryParameters", "title", "displayInCard"]);

  var _useClaims = (0, _useClaims2["default"])({
    accessToken: accessToken,
    environment: environment,
    queryParameters: queryParameters
  }),
      isLoadingClaims = _useClaims.isLoadingClaims,
      _useClaims$claims = _useClaims.claims,
      results = _useClaims$claims.results,
      total = _useClaims$claims.total,
      error = _useClaims.error;

  var _useTranslation = (0, _reactI18next.useTranslation)('reactClaims', {
    i18n: _i18n["default"]
  }),
      t = _useTranslation.t;

  (0, _react.useEffect)(function () {
    _i18n["default"].changeLanguage(language);
  }, [language]);
  var cardContent;

  if (isLoadingClaims) {
    cardContent = _react["default"].createElement(Spinner, {
      size: "medium"
    });
  } else if (error) {
    cardContent = _react["default"].createElement("p", null, t('failedToGetClaims'));
  } else if (total === 0) {
    cardContent = _react["default"].createElement("p", null, t('noClaimsFound'));
  } else {
    var link = generateLinkToComplaintsUi(environment, tenant, queryParameters);
    var claimSnippets = results.slice(0, displayLimit).map(function (claim) {
      return _react["default"].createElement(_Claim["default"], {
        key: claim.id,
        claim: claim,
        environment: environment,
        accessToken: accessToken,
        locale: locale || language
      });
    });
    cardContent = _react["default"].createElement(_react["default"].Fragment, null, claimSnippets, _react["default"].createElement(ViewAllWrapper, null, _react["default"].createElement("a", {
      href: link,
      target: "_blank",
      rel: "noopener noreferrer"
    }, t('seeAllClaims', {
      total: total
    }))));
  }

  return displayInCard ? _react["default"].createElement(_reactComponents.Card, (0, _extends2["default"])({
    header: title || t('title')
  }, props, {
    isMinimal: true
  }), cardContent) : cardContent;
};

Claims.propTypes = {
  accessToken: _propTypes["default"].string.isRequired,
  environment: _propTypes["default"].oneOf([_environments.PRODUCTION, _environments.INTEGRATION]),
  language: _propTypes["default"].oneOf(['en']),
  locale: _propTypes["default"].string,
  displayLimit: _propTypes["default"].number,
  tenant: _propTypes2.tenantShape,
  queryParameters: _propTypes2.queryParametersShape,
  title: _propTypes["default"].string,
  displayInCard: _propTypes["default"].bool
};
Claims.defaultProps = {
  environment: _environments.PRODUCTION,
  language: 'en',
  locale: undefined,
  displayLimit: 3,
  tenant: undefined,
  queryParameters: undefined,
  title: undefined,
  displayInCard: true
};
var _default = Claims;
exports["default"] = _default;